// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__vouev","inputWrapper":"styles_inputWrapper__zftK+","inputCard":"styles_inputCard__RxLC2","empty":"styles_empty__xU6u6"};